const toggles = [...document.querySelectorAll(`.toggle__item`)];
const text = {
  [`museum`]: {
    ru: `Музеи`,
    en: `Museum`,
    cn: `博物馆`
  },
  [`entertainment`]: {
    ru: `Досуг`,
    en: `Leisure`,
    cn: `娱乐`
  },
  [`schools`]: {
    ru: `Школы`,
    en: `Schools`,
    cn: `学校`
  }
};

export default (markers, locale) => {
  toggles.forEach((toggle) => {
    toggle.addEventListener(`click`, ({currentTarget}) => {
      const type = currentTarget.dataset.toggle;
      const parent = currentTarget.closest(`.toggle`);
      const control = parent.querySelector(`.toggle__control`);

      control.className = `toggle__control toggle__control--${type}`;
      control.textContent = text[type][locale];

     filterMarkers(markers, type);
    });
  });
};

export const filterMarkers = (markers, type) => {
  markers.forEach(marker => {
    const markerTypes = !!marker.type && JSON.parse(marker.type);

    if (markerTypes) {
      marker.div.classList.toggle(`place__marker--hidden`, !markerTypes.includes(type));
    }
  });
};
